var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-fab md-primary md-fab-bottom-right md-fab_notifications",style:({ marginTop: ("-" + _vm.clientHeight + "px") })},[_c('md-icon',[_vm._v(_vm._s(_vm.iconName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }